export default __webpack_public_path__ + "static/media/lightbulb.052e1ddb.svg";